import React, { useState ,useEffect} from 'react';
import { Container, Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import * as Yup from "yup";
import {useNavigate} from 'react-router-dom';
import Axios from '../../lib/axios/axiosInstance';

import { Formik } from "formik";
import { Flip, Slide, toast } from 'react-toastify';
import { userLogIn } from "../../services/auth";
import './Login.styles.css';
import * as AuthVerify from '../../lib/common';

const CorporateformSchema = Yup.object().shape({
  email: Yup.string().required("Username is required")
});

const Login = () => {
  const navigate = useNavigate();

  const logInFormHandler = async (values, url) => {
    const val = {
      username: values.email.toLowerCase(),
      password: values.passWord
    }
    const response = await userLogIn(val, url);
    if (response && response.status == 200) {
      
      await AuthVerify.setSession(response.data).then(async result =>{
        toast.success('Log In Successful', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Slide,
        });
        // await AuthVerify.getCartRef(true);
        await Axios.get(`/cart/activecarth?username=${response.data.email}&arnum=${response.data.arnum}`)
        .then(async (refnum) => {
          if (refnum?.data && refnum.status == 200) {
            response.data.refnum=refnum.data.refnum;
            response.data.cartChanged=true;
          }
        });
        navigate('/')
      })
    }
    else {
      toast.error('Username or Password is Invalid', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      })
    }
  }

  useEffect(() => { 
    if(AuthVerify.isUserLogedIn()){
      navigate('/');
    }
	},[])

  const [initialValue, setInitialValue] = useState({
    email: "",
  });
  return (
    <section className="main-container col1-layout">
      <Container className="main">
        <Row className='justify-content-center'>
          <Col xs={12} sm={6} lg={12}>
            <div className="account-login">
              <div className="page-title">
                <h2>Log In</h2>
              </div>
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformSchema}
                onSubmit={(values, { setSubmitting }) => {
                  const url = "accounts/authenticate"
                  logInFormHandler(values, url)
                  setSubmitting(false);
                }}
                validate={(values) => {
                  let errors = {};
                  return errors;
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="col-1 registered-users">
                      <p>Welcome Back, Please enter your credentials.</p>
                      <div className="content">
                        <div className="form-list">
                          <Row>
                            <Col sm={6}>
                              <InputField
                                Name="email"
                                id="email"
                                Labels="Username"
                                Type="text"
                                value={values.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                                className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                              // onBlur={handleBlur}

                              // error={errors.firstName && touched.firstName && errors.firstName}
                              />
                              <InputField
                                Type="password"
                                Labels="Password"
                                Name="passWord"
                                value={values.passWord}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={!!errors.passWord}
                                className={"input-text required-entry validate-password" + (errors.passWord && touched.passWord) && 'is-invalid'}
                              // onBlur={handleBlur}

                              // error={errors.firstName && touched.firstName && errors.firstName}
                              />
                              <button
                                id="send2"
                                name="send"
                                type="submit"
                                className="button login"
                              >
                                <span>Login</span>
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>

                  </form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Login;
